import Vue from "vue"

import sidepane from "./plugins/sidepane/sidepane"
import dropdown from "./plugins/dropdown/dropdown"
import interact from "./plugins/interact/interact"
import keyboard from "./plugins/keyboard/keyboard"
import messages from "./plugins/messages/messages"
import popup from "./plugins/popup/popup"
import sideload from "./plugins/sideload/sideload"
import marquee from "./plugins/marquee/marquee"
import toast from "./plugins/toast/toast"
import channel from "./plugins/channel"
import hsm from "./plugins/hsm"

Vue.use(sidepane)
Vue.use(dropdown)
Vue.use(interact)
Vue.use(keyboard)
Vue.use(messages)
Vue.use(popup)
Vue.use(sideload)
Vue.use(marquee)
Vue.use(toast)
Vue.use(channel)
Vue.use(hsm)
